import { useEffect } from 'react'
import { Stack, Button } from '@mui/material'
import { useNavigate } from "react-router-dom";

import { useTranslation } from 'react-i18next';

import { ReactComponent as Logo} from '../assets/404.svg'

function NotFound() {
  const navigate = useNavigate();

  const { t } = useTranslation()

  function handleClick() {
    navigate("/");
  }

  useEffect(() => {
    document.title = t("not_found.page_title")
  }, [])

  return (
    <Stack direction='column' alignItems="center" justifyContent='center' height="100vh" spacing={3}>
      <Logo height="40vh"/>
      <Button variant="contained" size='large' sx={{ borderRadius: '10px' }} onClick={handleClick}>{t("not_found.back_to_home_button")}</Button>
    </Stack>
  )
}

export default NotFound